<template>
    <v-dialog v-model="dialog" content-class="modal-dialog">
        <v-card class="modal-motion-history">
            <div class="common-text mb-2">
                История событий
            </div>
            <v-layout column ma-0 class="main-text mb-5 w-100 motion-list scrollbar-block" v-if="motionHistory.length">
                <v-flex xs12 v-for="(action, index) in motionHistory" :key="index" class="motions">
                    <v-layout v-if="action.new_day" class="motions__title bold-text">
                        {{action.new_day}}
                    </v-layout>
                    <v-flex class="motion-row">
                        <div class="motion-row__time">
                            <div class="d-inline-flex">
                                начало: {{action.start_updated}}
                                <div class="ml-3">
                                    конец: {{action.end_updated}}
                                </div>
                            </div>
                            <div>длительность: {{action.text_duration}}</div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout column ma-0 class="main-text mb-5 w-100 motion-list text-center grey-text" v-else>
                Нет доступной истории
            </v-layout>
            <v-flex class="d-flex w-100 justify-end mt-6">
                <v-btn class="btn-grey main-text" @click="close">
                    Закрыть
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import {getTimeFromDate} from "@/utils";
import { timeWithTZ } from '@/utils/index';

export default {
    name: "ModalMotionHistory",
    props: {
        value: {
            type: Boolean,
        },
        history: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            dialog: false,
            motionHistory: [],
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('input', false);
            }
        },
        history(val) {
            if (val) {
                this.setMotionHistory();
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.$emit('input', false);
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
        setMotionHistory() {
            this.motionHistory = JSON.parse(JSON.stringify(this.history));
            this.motionHistory.forEach((motion, index) => {
                motion.start_updated = this.getTime(motion.start);
                motion.end_updated = this.getTime(motion.end);
                motion.text_duration = this.formattedDuration(motion.duration);
                if (index > 0) {
                    if (this.checkDay(motion.start) != this.checkDay(this.motionHistory[index - 1].start)) {
                        motion.new_day = this.checkDay(motion.start);
                        motion.new_day = this.reverseDate(motion.new_day);
                    }
                } else {
                    motion.new_day = this.checkDay(motion.start);
                    motion.new_day = this.reverseDate(motion.new_day);
                }
            });
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-motion-history.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .motion-list {
        min-height: 400px;
        max-height: 60vh;
        overflow-y: auto;
    }

    .motions {
        &:not(:last-child) {
            border-bottom: 1px solid #787878;
        }

        &__title {
            margin: 10px 0;
            background: #ffd9b3;
            justify-content: center;
            border-radius: 30px;
        }

        .motion-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            min-height: 44px;

            &:not(:last-child) {
                border-bottom: 1px solid #787878;
            }

            &__time {
                display: inline-flex;
                flex-direction: column;
            }

            .v-image{
                max-height: 36px;
                max-width: 36px;
            }
        }
    }
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
}
</style>